// custom settings that work with our own OAuth server
import { authConfig as auth } from '../../auth/keycloak/config';

const DEFAULT_AUTH_SCOPES = 'openid profile email';

const getConfiguredScopes = (): string | undefined => {
  const env = import.meta.env as ImportMetaEnv & { VITE_AUTH_SCOPES?: string };
  const raw = process.env.NODE_ENV === 'development' ? env.VITE_AUTH_SCOPES : window._env_?.AUTH_SCOPES;
  if (raw === undefined || raw === null) return undefined;
  const trimmed = String(raw).trim();
  if (trimmed === '') {
    console.warn('[Auth] AUTH_SCOPES is set but empty or whitespace; using default scopes.');
    return undefined;
  }
  return trimmed;
};

export const authConfig = {
  response_type: 'code',
  scope: getConfiguredScopes() ?? DEFAULT_AUTH_SCOPES,
  authority: auth.authority,
  client_id: auth.clientId,
  redirect_uri: window.location.origin + window.location.pathname,
  post_logout_redirect_uri: window.location.origin,
  // userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  monitorSession: true, // this allows cross tab login/logout detection
  extraQueryParams: {
    audience: auth.audience,
  },
};

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
